export const useTaxID = () => {
  const validateCpf = (cpf: string): boolean => {
    // Remove non-numeric characters
    const cleanCpf = cpf.replace(/\D/g, '')
    if (cleanCpf.length !== 11 || /^(\d)\1+$/.test(cleanCpf)) return false

    // Calculate verifier digits
    const calcDigit = (cpf: string, length: number) => {
      let sum = 0
      for (let i = 0; i < length; i++) sum += +cpf[i] * (length + 1 - i)
      const digit = (sum * 10) % 11
      return digit === 10 ? 0 : digit
    }

    return (
      calcDigit(cleanCpf, 9) === +cleanCpf[9] &&
      calcDigit(cleanCpf, 10) === +cleanCpf[10]
    )
  }

  const validateCnpj = (cnpj: string): boolean => {
    const cleanCnpj = cnpj.replace(/\D/g, '')

    // check if the CNPJ has 14 digits and are not all the same
    if (cleanCnpj.length !== 14 || /^(\d)\1+$/.test(cleanCnpj)) return false

    // Calculation of two check digits
    const calcDigit = (cnpj: string, length: number): number => {
      const weights =
        length === 12
          ? [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
          : [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]

      const sum = cnpj
        .split('')
        .slice(0, length)
        .reduce((acc, num, idx) => acc + +num * weights[idx], 0)

      const remainder = sum % 11

      return remainder < 2 ? 0 : 11 - remainder
    }

    const firstDigit = calcDigit(cleanCnpj, 12)
    const secondDigit = calcDigit(cleanCnpj, 13)

    return firstDigit === +cleanCnpj[12] && secondDigit === +cleanCnpj[13]
  }

  const formatCPF = (cpf: string) => {
    if (!cpf) return ''

    cpf = cpf.replace(/\D/g, '')
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
  }

  const formatCNPJ = (cnpj: string) => {
    if (!cnpj) return ''

    cnpj = cnpj.replace(/\D/g, '')
    return cnpj.replace(
      /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
      '$1.$2.$3/$4-$5'
    )
  }

  const validateTaxID = (value: string) => {
    value = value.replace(/\D/g, '')
    if (!value) return false

    if (value.length === 11) return validateCpf(value)

    return validateCnpj(value)
  }

  return {
    validateTaxID,
    formatCPF,
    formatCNPJ,
  }
}
